
(function() {

    require('./app/language_switch.js');
    require('./app/data_forms.js');
    require('./app/take_picture.js');
    require('./app/feedback.js');
    require('./app/redirect_page.js');
}());